export default __webpack_public_path__ + "static/media/setting_svg.d2823afc.svg";